import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/licensingslides')({
  beforeLoad: () => {
    throw redirect({ to: '/education' })
  },
})
